export default function isEnterOrSpace({ keyCode }) {
  return keyCode === 13 || keyCode === 32
}
